import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResetCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22 40.85q-5.65-.7-9.324-4.926Q9 31.7 9 26q0-3.05 1.2-5.85t3.4-4.9l2.1 2.15a10.6 10.6 0 0 0-2.774 3.874A12.2 12.2 0 0 0 12 26q0 4.4 2.8 7.75t7.2 4.1zm4 .05v-3q4.35-.9 7.174-4.2Q36 30.4 36 26q0-5-3.5-8.5T24 14h-.7l2.7 2.7-2.1 2.1-6.3-6.3 6.3-6.3L26 8.3 23.3 11h.7q6.3 0 10.65 4.35T39 26q0 5.65-3.7 9.85T26 40.9" })
});
export default SvgResetCamera;
